import { get } from './requests'

export const getAudienceFilters = () => get(['enums-apa', 'audience-filters'], {}, {})

// The OMM delivery destinations catalogue, from apa-api's enum, so this page does
// not restate it.
export const getOmmDestinations = (env) => get(['enums-apa', 'omm-destinations'], {}, { env })
